import { Component, OnInit, Input, SimpleChanges } from '@angular/core'
import { DbService } from '../../services/db.service'
import IntervalTree from 'node-interval-tree'
import { Subscription } from 'rxjs'
import * as uuid from 'uuid/v1'

@Component({
  selector: 'app-booking-event',
  templateUrl: './booking-event.component.html',
  styleUrls: ['./booking-event.component.css']
})
export class BookingEventComponent implements OnInit {

  @Input() booking;
  @Input() bookings;
  @Input() bookingObjects;
  @Input() combinations;
  @Input() event;
  @Input() webBlocks;

  antal = 0
  slots = []
  combcomb = []
  hideRed = false
  csi = 2
  csiFrom = 1

  busSubscription: Subscription

  constructor(public db: DbService) {

    this.busSubscription = this.db.msgBusGetMessage().subscribe(message => {

      //if (this.db.debug) console.log("booking-grid msgBus incoming message", message);

      if (message.text == "calchange") setTimeout(() => { 
        this.createSlots() 
      }, 200)

    })

    //if (this.db.system == 'namdo') this.hideRed = true
    
  }

  ngOnInit() {
    
  }

  ngOnChanges(changes: SimpleChanges) {
    setTimeout(() => { 
      this.createSlots()
    }, 200)
  }  

  antalChange() {
    if (this.event.resource.isrestaurant) this.booking.persons = +this.antal
    
    this.booking.bookingItems = this.booking.bookingItems.filter(bi => bi.idResource != this.event.idResource)
    this.db.collapseBookingItems(this.booking, this.bookingObjects)
    
    this.checkAvailable()
  }

  getRange(from, i) {
    var x = []
    for (var n = from; n <= i; n++) x.push(n)
    return x
  }

  createSlots() {

    this.csi = this.event.resource.csi
    if (this.event.csi) this.csi = this.event.csi

    this.slots = []
   
    var estart = this.event.start - this.event.prebooking
    var eend = +this.event.start

    if (this.event.eventType == 2) {
      estart = this.event.start
      eend = this.event.start + this.event.prebooking - this.event.duration
    }

    let api = this.event.resource.api
    if (this.event.api) api = this.event.api

    let ppi = this.event.resource.ppi
    if (this.event.ppi) ppi = this.event.ppi

    let duration = this.event.resource.defaultduration
    if (this.event.duration) duration = this.event.duration

    for (var i = estart; i <= eend; i += 15) {
      this.slots.push({ start: i, available: false, selected: false, api: 0, ppi: 0, availables: [], maxApi: api, maxPpi: ppi, duration: duration })
    }

    if (this.event.allowedStarts && this.event.allowedStarts.length) {
      this.slots = []
      this.event.allowedStarts.sort(this.db.sortSortOrder).filter(as => as.active).forEach(as => {
        if (as.api) api = as.api
        if (as.ppi) ppi = as.ppi
        if (as.duration) duration = as.duration
        this.slots.push({ start: as.start, available: false, selected: false, api: 0, ppi: 0, availables: [], maxApi: api, maxPpi: ppi, duration: duration })
      })
    }

    //if (this.db.system == 'namdo') {
    //    this.slots = []
    //    if (this.db.workday < '2019-07-01') {
    //        this.slots.push({ start: 690, available: false, selected: false, api: 0, ppi: 0, availables: [] })
    //        this.slots.push({ start: 720, available: false, selected: false, api: 0, ppi: 0, availables: [] })
    //        this.slots.push({ start: 870, available: false, selected: false, api: 0, ppi: 0, availables: [] })            
    //    }
    //    if (this.db.workday > '2019-06-30') {
    //        this.slots.push({ start: 660, available: false, selected: false, api: 0, ppi: 0, availables: [] })
    //        this.slots.push({ start: 675, available: false, selected: false, api: 0, ppi: 0, availables: [] })
    //        this.slots.push({ start: 825, available: false, selected: false, api: 0, ppi: 0, availables: [] })            
    //        this.slots.push({ start: 840, available: false, selected: false, api: 0, ppi: 0, availables: [] })            
    //    }
    //}

//    if (this.db.system == 'cabotaqueria' && this.event.descr != 'Lunch') {
//
//      this.slots = []
//      // Chefs table
//      if (this.event.id == '0c319782-6fbe-3f3a-de94-11a36771d3bb' || this.event.id == '22907c99-c148-3e14-21db-fa4fba2b0191') {
//        this.slots.push({ start: 960, available: false, selected: false, api: 0, ppi: 0, availables: [] })
//        this.slots.push({ start: 1095, available: false, selected: false, api: 0, ppi: 0, availables: [] })
//        this.slots.push({ start: 1230, available: false, selected: false, api: 0, ppi: 0, availables: [] })
//      }
//      // VIP
//      if (this.event.id == 'b67f3a39-cb84-92ec-734a-7cfa9bcf8bba' || this.event.id == 'd58b6439-5c9f-aae3-c7b2-a2ee87afbd11') {
//        this.slots.push({ start: 990, available: false, selected: false, api: 0, ppi: 0, availables: [] })
//        this.slots.push({ start: 1200, available: false, selected: false, api: 0, ppi: 0, availables: [] })
//
//      }
//    }

    this.combcomb = []
    // Kombinera kombinationer och bokningsbara bokningsobjekt
    //this.combcomb = this.combinations.filter(c => c.idResource == this.event.idResource) // Replaced by 3 lines below to add zones
    this.combinations.filter(c => c.idResource == this.event.idResource && c.webbookable).forEach(c => {
      //c["zones"] = this.bookingObjects.filter(bo => bo.id == c.bookingObjects[0].id)[0].zones
      this.bookingObjects.filter(bo => bo.id == c.bookingObjects[0].id).forEach(bo => {
        c["zones"] = bo.zones
      })
      this.combcomb.push(c)
    })

    this.bookingObjects.filter(bo => bo.idResource == this.event.idResource && bo.webbookable).forEach(bo => {
      this.combcomb.push({id: bo.id, name: bo.name, bookingObjects: [{id: bo.id, sortorder: 0}], seats: bo.seats, minseats: bo.minseats, idResource: bo.idResource, prio: bo.prio, zone: bo.zone, zones: bo.zones, deleted: false, sortorder: bo.sortindex})
    })

    if (this.event.allowedItems && this.event.allowedItems.length) {

      this.combcomb = []

      this.event.allowedItems.forEach(ai => {

        this.bookingObjects.filter(bo => bo.id == ai.idItem).forEach(bo => {
          this.combcomb.push({id: bo.id, name: bo.name, bookingObjects: [{id: bo.id, sortorder: 0}], seats: bo.seats, minseats: bo.minseats, idResource: bo.idResource, prio: bo.prio, zone: bo.zone, zones: bo.zones, deleted: false, sortorder: bo.sortindex})    
        })

        this.combinations.filter(c => c.id == ai.idItem).forEach(c => {
          this.bookingObjects.filter(bo => bo.id == c.bookingObjects[0].id).forEach(bo => {
            c["zones"] = bo.zones
          })
          this.combcomb.push(c)     
        })

      })

    }

    if (this.db.system == 'dahlboms' && this.event.descr == 'chefs table' && this.db.workday <= '2021-01-15') this.csiFrom = 2
    if (this.db.system == 'dahlboms' && this.event.descr == 'chefs table' && this.db.workday > '2021-01-15') this.csiFrom = 4
    if (this.db.system == 'dahlboms' && this.event.descr == 'chefs table' && this.db.workday == '2021-01-16') this.csiFrom = 2
    
    if (this.db.system == 'bird' && this.event.descr == 'baren') this.csiFrom = 4
    
    if (this.event.minPersons) this.csiFrom = this.event.minPersons

//    if (this.db.system == 'cabotaqueria' && this.event.descr != 'Lunch') {
//
//      this.combcomb = []
//
//      // VIP
//      //if (this.event.id == 'b67f3a39-cb84-92ec-734a-7cfa9bcf8bba' || this.event.id == 'd58b6439-5c9f-aae3-c7b2-a2ee87afbd11') {
//      //  this.csiFrom = 8
//      //  this.bookingObjects.filter(bo => bo.idResource == this.event.idResource && bo.number == 1000).forEach(bo => {
//      //    this.combcomb.push({id: bo.id, name: bo.name, bookingObjects: [{id: bo.id, sortorder: 0}], seats: bo.seats, minseats: bo.minseats, idResource: bo.idResource, prio: bo.prio, zone: bo.zone, zones: bo.zones, deleted: false, sortorder: bo.sortindex})
//      //  })
//      //}
//
//      // Chefs table
//      if (this.event.id == '0c319782-6fbe-3f3a-de94-11a36771d3bb' || this.event.id == '22907c99-c148-3e14-21db-fa4fba2b0191') {
//        this.combcomb = []
//        this.bookingObjects.filter(bo => bo.idResource == this.event.idResource && (bo.number >= 1 && bo.number <= 4)).forEach(bo => {
//          this.combcomb.push({id: bo.id, name: bo.name, bookingObjects: [{id: bo.id, sortorder: 0}], seats: bo.seats, minseats: bo.minseats, idResource: bo.idResource, prio: bo.prio, zone: bo.zone, zones: bo.zones, deleted: false, sortorder: bo.sortindex})
//        })   
//        this.combinations.filter(c => c.idResource == this.event.idResource && c.prio > 2000).forEach(c => {
//          this.bookingObjects.filter(bo => bo.id == c.bookingObjects[0].id).forEach(bo => {
//            c["zones"] = bo.zones
//          })
//          this.combcomb.push(c)
//        })      
//      }
//
//    }


    this.combcomb.sort(function(a, b) {
      if (+a.prio < +b.prio) return -1;
      if (+a.prio > +b.prio) return 1;
      return 0;
    });    

  }

  checkAvailable() {

    // Skapa ivt
    var ivt = new IntervalTree()
    this.bookings.forEach(b => {
      b.bookingItems.filter(bi => bi.idResource == this.event.idResource).forEach(bi => {
        if (bi.start + bi.duration - 1 > bi.start) ivt.insert(bi.start, bi.start + bi.duration + +this.event.resource.cleaningtime - 1, bi.idBookingObject)
        //console.log('ivt', bi.start, bi.start + bi.duration - 1, bi.idBookingObject)
      })
    })

    // Testa varje slot
    this.slots.forEach(slot => {

      // Nollställ slot
      slot.selected = false
      slot.available = true
      slot.availables = []
      slot.availableNames = []
      slot.api = 0
      slot.ppi = 0
      slot.reasons = []

      this.webBlocks.filter(wb => wb.idResource == this.event.id && wb.time == slot.start).forEach(wb => { slot.available = false })

      if (this.db.isToday()) {
        var d = new Date()
        var currentMinute = d.getHours() * 60 + d.getMinutes()
        var karens = +this.db.setting.karens
        if (this.event.resource.webkarens) karens = this.event.resource.webkarens
        if (this.event.karens) karens = this.event.karens
        if (karens == 0) karens = 1

        // Stopptid om karens < 20
        //if (karens < 20 && currentMinute > karens * 60) slot.available = false

        if (slot.start < currentMinute + karens) slot.available = false
        if (this.db.setting.webstop && currentMinute > this.db.setting.webstop * 60) slot.available = false
      }

      // Check if arrivals per interval (api) or persons per interval (ppi) is reached
      if (this.event.resource.isrestaurant) {
        this.bookings.forEach(b => {
          var nybokn = true;
          b.bookingItems.filter(bi => bi.idResource == this.event.idResource && bi.start == slot.start).forEach(bi => {
            //var persons = +b.persons
            //if (typeof bi.persons !== 'undefined') persons = +bi.persons
            //console.log(b.id, b.persons, bi.persons, persons)
            //slot.ppi += +persons
            if (nybokn) {
              slot.api++
              //if (slot.start == 720) console.log(b)
              slot.ppi += +b.persons
              nybokn = false;
            }
          });
        });
      }
            
      // Testa alla kombinationer som har rätt antal platser
      this.combcomb.filter(c => this.antal >= +c.minseats && this.antal <= +c.seats).forEach(c => {
        
        var available = true;
        
        // Testa alla obj i kombinationen var för sig
        c.bookingObjects.forEach(t => {
          
          // Kolla om bokning existerar på denna interval.
          let found = false
          if (this.event.eventType == 1) {
            
            if (!ivt.search(slot.start, +slot.start + slot.duration + +this.event.resource.cleaningtime + (this.event.start - slot.start) - 1).filter(i => i == t.id).length) {
              found = true;
              //slot.reasons.push('1')
            }
          } else {
            if (!ivt.search(slot.start, +slot.start + slot.duration - 1).filter(i => i == t.id).length) {
              console.log('Hello')
              found = true;
              //slot.reasons.push('2')
            }
          }

          if (!found) {
            available = false
            slot.reasons.push('1')
          }

          // Kolla zon
          if (available) {
            let found = false
            if (this.event.zones) this.event.zones.forEach(ez => {
              if (c.zones.filter(cz => cz == ez).length) found = true
              //if (slot.start == 19 * 60 + 15) console.log(ez, c.name, c.zones, found) 
            })
            if (!found && this.event.zones.length) {
              available = false
              slot.reasons.push('3')
            }
          }


        });

        // Om fortfarande available o...
        if (available) slot.availables.push(c.id)
        if (available) slot.availableNames.push(c.name)
      })

      // To many arrivals at slot?
      //if (slot.api + 1 > this.event.api) {
      //  slot.available = false
      //  slot.reasons.push('4')
      //}

      // To many persons at slot?
      
      //let ppi = this.event.ppi

      //if (this.db.system == 'namdo') {
      //    if (this.db.workday < '2019-07-01') {
      //      if (slot.start == 690) ppi = 54
      //      if (slot.start == 720) ppi = 30
      //    }
      //    if (this.db.workday > '2019-06-30') {
      //      if (slot.start == 660) ppi = 60
      //      if (slot.start == 675) ppi = 42
      //      if (slot.start == 825) ppi = 70
      //      if (slot.start == 840) ppi = 32
      //    }
      //}

      //if (slot.ppi + +this.antal > ppi) {
      //  slot.available = false;
      //  slot.reasons.push('5')
      //}      

      // No bookingobjects available
      if (!slot.availables.length) {
        slot.available = false
        slot.reasons.push('6')
      }      

    })

    this.slots.filter(s => s.api + 1 > s.maxApi).forEach(s => { s.available = false; s.reasons.push('5'); })
    this.slots.filter(s => s.ppi + +this.antal > s.maxPpi).forEach(s => { s.available = false; s.reasons.push('6'); })

  }

  slotClick(s) {
    
    if (!s.available) return

    this.booking.bookingItems = this.booking.bookingItems.filter(bi => bi.idResource != this.event.idResource)
    this.db.collapseBookingItems(this.booking, this.bookingObjects)

    if (s.selected) {
      
      s.selected = false

    } else {

      this.slots.forEach(s => s.selected = false)
      s.selected = true
      
      this.combcomb.filter(c => c.id == s.availables[0]).forEach(c => {
        //console.log('This combcomb', c)
        c.bookingObjects.forEach(bo => {

          var duration = s.duration + (this.event.start - s.start)
          if (this.event.eventType == 2) duration = s.duration

          this.booking.bookingItems.push({
            id: uuid(),
            idBookingObject: bo.id,
            idResource: this.event.idResource,
            idEvent: this.event.id,
            start: s.start,
            duration: duration,
            status: 0,
            persons: this.event.resource.isrestaurant ? this.antal : 0,
            price: 0,
            vat: 0
          })

        })

        if (this.event.tags) this.event.tags.forEach(tag => {
          if (!this.booking.tags.includes(tag)) this.booking.tags.push(tag)
        })
        
      })

      this.db.collapseBookingItems(this.booking, this.bookingObjects)

      this.db.msgBusSendMessage('sammanst')

    }
    
  }
  

}
